module.exports = __webpack_public_path__ + "static/media/pt-BR.74e7bedb.png";